export function AssertionError(message) {
    const error = new Error(message);
    error.name = 'AssertionError';
    return error;
}
export function NotImplementedError(message) {
    const error = new Error(message);
    error.name = 'NotImplementedError';
    return error;
}
export function InvalidEnvironmentError(message) {
    const error = new Error(message);
    error.name = 'InvalidEnvironmentError';
    return error;
}
export function NotInitializedError(message) {
    const error = new Error(message);
    error.name = 'NotInitializedError';
    return error;
}
//# sourceMappingURL=errors.js.map